import { Component, OnInit } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

import { SiteService } from '../../../../services/site.service'
import { LeaseTransferSummary } from '../../../../models/leaseTransferSummary'

@Component({
    selector: 'app-request-lease-transfer-summary',
    templateUrl: './request-lease-transfer-summary.component.html',
    styleUrls: ['./request-lease-transfer-summary.component.scss'],
    standalone: false
})
export class RequestLeaseTransferSummaryComponent implements OnInit 
{
	referenceNumber: string = ''
	effectiveDateIsValid: boolean = false
	summary = new LeaseTransferSummary()

	constructor(
		private siteService: SiteService,
		private translateService: TranslateService
	) 
	{ 
	}

	ngOnInit() 
	{
		if (this.siteService.viewParameters.hasOwnProperty('leaseTransferSummary') &&
			this.siteService.viewParameters.leaseTransferSummary.hasOwnProperty('referenceNumber') &&
			this.siteService.viewParameters.leaseTransferSummary.hasOwnProperty('data'))
		{
			this.referenceNumber = this.siteService.viewParameters.leaseTransferSummary.referenceNumber

			if ((this.referenceNumber != undefined) && (this.referenceNumber != ''))
			{
				this.retrieveInfo()
			}	  
		}
	}

	retrieveInfo()
	{
		this.summary.customerName = this.siteService.viewParameters.leaseTransferSummary.data.name
		this.summary.leaseNumber = this.siteService.viewParameters.leaseTransferSummary.data.leaseNumber
		this.summary.dealerName = this.siteService.viewParameters.leaseTransferSummary.data.dealerName
		this.summary.dealerAddress = this.siteService.viewParameters.leaseTransferSummary.data.dealerAddress
		this.summary.dealerPhone = this.siteService.viewParameters.leaseTransferSummary.data.dealerPhone
	}

	print(): void
	{
		this.siteService.printHtmlElement('printSummarySectionId', this.translateService.instant('REQUEST_SUMMARY_HEADING'))
	}
}
